angular.module('zc.zenclerkS')
  .component('zcsTerminated', {
    templateUrl: '/templates/zenclerk_s/sites/terminated/terminated.html',
    bindings: {
      project: '<'
    },
    controller: ZcsTerminated,
  });

ZcsTerminated.$inject = [];
function ZcsTerminated() {
  const vm = this;
  vm.$onInit = () => {
    vm.terminatedDate = moment(vm.project.terminated_at).format('YYYY/MM/DD');
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/terminated/terminated.component.js